import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { VariationDirective } from '../../directives';

export enum IndicatorStatus {
    Error = 'error',
    Warning = 'warning',
    Success = 'success',
    Locked = 'locked',
    Default = 'default',
    Complete = ' complete',
    Info = 'info',
}

@Component({
    selector: 'fi-status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls: ['./status-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [VariationDirective],
})
export class StatusIndicatorComponent {
    @Input() status: IndicatorStatus;
}
